<script setup lang="ts">
import { DropdownMenuItem as Item } from 'reka-ui';
import { cn } from '@/lib/cn';

const props = defineProps<{ class?: string; disabled?: boolean }>();
const emit = defineEmits<{ select: [event: Event] }>();
</script>

<template>
  <Item
    :disabled="props.disabled"
    :class="cn(
      'relative flex items-center gap-2 px-3 py-2 rounded-md text-[14px] text-text cursor-pointer outline-none select-none',
      'data-[highlighted]:bg-bg data-[highlighted]:text-text',
      'data-[disabled]:opacity-50 data-[disabled]:pointer-events-none',
      props.class,
    )"
    @select="(e) => emit('select', e)"
  >
    <slot />
  </Item>
</template>
